module.exports = "<div class=\"project-list-data\">\n    <div id=\"grid\" ui-grid=\"vm.gridOptions\" class=\"grid\" ui-grid-resize-columns ui-grid-infinite-scroll ui-grid-move-columns></div>\n    <div class=\"no-rows\" ng-if=\"!vm.gridOptions.data.length\">\n        <div class=\"msg\">\n            <h3 class=\"header\">{{ 'NO_DATA' | translate }}</h3>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/projects/projects-list/projectsListData.tpl.html
// module id = 1820
// module chunks = 0